import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

import SelectCore from './SelectCore';

class SelectCitizenships extends SelectCore {
  defaultPlaceholder = () => {
    const { placeholder } = this.props;

    return placeholder || I18n.t('web.users.search.nationalities');
  };

  renderOptions = () => {
    const { currentNetwork, citizenships, blankValue } = this.props;

    const actualCitizenships = citizenships || currentNetwork.nationalities;

    const citizenshipsOptions = actualCitizenships.map((citizenship) => (
      <option value={citizenship.id} key={citizenship.id}>
        {citizenship.text || citizenship.name}
      </option>
    ));

    if (blankValue) {
      citizenshipsOptions.unshift(
        <option key="default" value="" disabled="disabled" />,
      );
    }

    return citizenshipsOptions;
  };
}

export default withDefaultAppContexts(SelectCitizenships);
